import React, { Component } from 'react'
import './index.less'
interface OrderPriceProps {
  price: string
  transportFee: string
  integral: string
  coupon: string
  total: string
}
export default class OrderTotalPrice extends Component<OrderPriceProps> {

  _transportItem() {
    return <div className='total-line'>
      <span className='total-dark'>配送费</span>
      <span className='total-orange'>￥{this.props.transportFee}</span>
    </div>
  }

  _integralItem() {
    return <div className='total-line'>
      <span className='total-dark'>积分抵扣</span>
      <span className='total-orange'>-￥{this.props.integral}</span>
    </div>
  }

  _couponItem() {
    return <div className='total-line'>
      <span className='total-dark'>优惠券</span>
      <span className='total-orange'>-￥{this.props.coupon}</span>
    </div>
  }

  render() {
    let transportFee = parseFloat(this.props.transportFee)
    let integralFee = parseFloat(this.props.integral)
    let couponFee = parseFloat(this.props.coupon)

    return (
      <div className='total-content'>
        <div className='total-line'>
          <span className='total-dark'>商品实付</span>
          <span className='total-dark'>￥{this.props.price}</span>
        </div>
        {transportFee > 0 && this._transportItem()}
        {integralFee > 0 && this._integralItem()}
        {couponFee > 0 && this._couponItem()}
        <div className='total-bottom'>
          <span></span>
          <span className='total-orange'>合计 ￥{this.props.total}</span>
        </div>
      </div>
    )
  }
}